import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from 'formik';
import { skuSubmit, setSubStage, setSelectedAddOns, setUserAddOnDetails, setHdfcAddOnDetails } from '../../../../slices/eligibility/eligibilitySlice';
import { toast } from 'react-toastify';
import Loader from '../../../common/Loader';
import NoImageComponent from '../../../common/NoImage';
import ImageComponent from '../../../common/Image';
import { toTitleCaseAdvanced } from '../../../../utils/functions';
import { useNavigate } from 'react-router-dom';

function Summary({ data }) {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const { dealerCode, referenceId } = useSelector(state => state.dashboard);
const navigate = useNavigate();
    const min = data?.jsonData?.sku_min_fin_amt;
    const max = data?.jsonData?.sku_max_fin_amt;
    const sku_id = data?.jsonData?.sku_create_id;
    const href = "#"
    const [displayValue, setDisplayValue] = useState('');

    const formik = useFormik({
        initialValues: {
            product_cost: ''
        },
        validate: (values) => {
            const errors = {};
            const cost = Number(values.product_cost);

            if (!values.product_cost) {
                errors.product_cost = 'Product Price is Required';
            } else if (!/^\d+$/.test(values.product_cost)) {
                errors.product_cost = 'Only digits allowed';
            } else if (cost < min || cost > max) {
                errors.product_cost = `Enter Product Price between ${min} and ${max}`;
            }

            return errors;
        },
        onSubmit: async (values) => {
            const payload = {
                ...values,
                reference_id: referenceId,
                sku_id: sku_id,
                dealer_code: dealerCode?.split('-')[0]?.trim(),
                sku_max_fin_amt: max,
                sku_min_fin_amt: min,
                category: data?.product,
                brand: data?.brand?.brand_name,
                model: data?.model,
                variant: data?.jsonData?.variant,
                description: data?.jsonData?.description, ...data?.jsonData
            };

            setLoader(true);
            const response = await dispatch(skuSubmit(payload));
            setLoader(false);

            if (response?.payload?.response_code === 'S100') {
                dispatch(setSelectedAddOns([]));
                dispatch(setUserAddOnDetails());
                dispatch(setHdfcAddOnDetails());
                dispatch(setSubStage("scheme"));
            }
            else if(response?.payload?.response_code === 'E135'){
toast.error(response?.payload?.response_string || "Something went wrong", {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
                    navigate('/dashboard')
            } else {
                !response?.payload?.error &&
                    toast.error(response?.payload?.response_string || "Something went wrong", {
                        position: 'top-right',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined
                    });
            }
        }
    });

    useEffect(() => {
        if (formik.values.product_cost) {
            setDisplayValue(formatINR(formik.values.product_cost));
        }
    }, [formik.values.product_cost]);

    const formatINR = (value) => {
        const number = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : Number(value);
        if (isNaN(number)) return '';
        return new Intl.NumberFormat('en-IN').format(number);
    };

    return (
        <>
            <div className="col-md-9 col-sm-12 Side-bank-Right">
                <div className="col-12 mb-1 static-tab">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex gap-2 align-items-center">
                            <p className="Pname-i mb-0">
                            </p>
                            <div
                                className="lh-0"
                                role="button"
                                tabIndex={0}
                                onClick={() => dispatch(setSubStage("brand"))}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        dispatch(setSubStage("brand"));
                                    }
                                }}
                            >

                                <p className="text-decoration-none grey small mb-0">Brand</p>
                                <p class="small mb-0 fw-600">{toTitleCaseAdvanced(data?.brand?.brand_name || '')}</p>
                            </div>
                            <span className="icon-arrowright-L1 blue"></span>
                            <div
                                className="lh-0"
                                role="button"
                                tabIndex={0}
                                onClick={() => dispatch(setSubStage("category"))}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        dispatch(setSubStage("category"));
                                    }
                                }}
                            >

                                <p className="text-decoration-none grey small mb-0">Category</p>
                                <p class="small mb-0 fw-600">{toTitleCaseAdvanced(data?.product?.category || '')}</p>
                            </div>
                            <span className="icon-arrowright-L1 blue"></span>
                            <div
                                className="lh-0"
                                role="button"
                                tabIndex={0}
                                onClick={() => dispatch(setSubStage("variant"))}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        dispatch(setSubStage("variant"));
                                    }
                                }}
                            >
                                <p className="text-decoration-none blue fs-14 mb-0">Model</p>
                                {/* <p class="small  mb-0 fw-bold">{toTitleCaseAdvanced(data?.jsonData?.model|| '')}</p> */}
                                {/* <p className="small  mb-0 fw-bold">{data?.jsonData?.model || ''}</p> */}
                            </div>
                            {/* <span className="icon-arrowright-L1"></span>
                            <a href={href} className="text-decoration-none dark-blue small">Summary</a> */}
                        </div>
                    </div>
                </div>

                <div className="row gy-4 mt-2">
                    <div className="col-12">
                        <div className="product-details px-4 py-4 position-relative">
                            <div className="d-flex gap-3">
                                <img loading="lazy"
                                    src={data?.jsonData?.category_image_url}
                                    className="img-fluid"
                                    alt="Product"
                                    width='150px'
                                    height='150px'
                                />
                                <div className="dataView row">
                                    <div className="col-12 d-none">
                                        <p>
                                            <label htmlFor='product'>Product</label>{' '}
                                            <span >{toTitleCaseAdvanced(data?.product || '')}</span>
                                        </p>
                                    </div>
                                    <div className="col-12 d-none">
                                        <p>
                                            <label htmlFor='brand'>Brand</label>{' '}
                                            <span >{toTitleCaseAdvanced(data?.brand || '')}</span>
                                        </p>
                                    </div>
                                    <div className="col-12 d-flex align-items-center">
                                        <p>
                                            <label className='d-none' htmlFor='variant'>Description</label>{' '}
                                            <span >{data?.jsonData?.description}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <ImageComponent
                                fileName="wave.svg"
                                className="wave-img d-none"
                                alt="Decorative wave"
                            />
                        </div>
                    </div>


                    <div className="col-6"></div>
                    <div className="col-6 text-end">
                        <label htmlFor="product_cost" className="form-label text-end w-100">
                            Product Price
                        </label>
                        <div className="d-flex">
                            <span className="font-serif mx-0 align-content-center fs-16 dark-blue">₹</span>
                            <input
                                id="product_cost"
                                name="product_cost"
                                type="tel"
                                className={`ps-0 form-control input-underline w-100 custom-cost text-end`}
                                placeholder="Enter"
                                value={displayValue}
                                onChange={(e) => {
                                    const raw = e.target.value.replace(/,/g, '');

                                    if (/^\d*$/.test(raw)) {
                                        if (raw === '' || Number(raw) <= max) {
                                            formik.setFieldValue('product_cost', raw);
                                            setDisplayValue(formatINR(raw));
                                        }
                                    }
                                }}
                                onBlur={formik.handleBlur}
                            />

                        </div>
                        {formik.touched.product_cost && formik.errors.product_cost && (
                            <div className="text-danger text-end small">{formik.errors.product_cost}</div>
                        )}
                    </div>
                </div>
            </div>

            <footer className="sticky-bottom-1">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="d-flex justify-content-between gap-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary"
                                    onClick={() => dispatch(setSubStage("category"))}
                                >
                                    Change product
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={formik.handleSubmit}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            {loader && <Loader />}
        </>
    );
}

// ✅ PropTypes validation for SonarLint/ESLint
Summary.propTypes = {
    data: PropTypes.shape({
        image: PropTypes.string,
        product: PropTypes.string,
        brand: PropTypes.string,
        model: PropTypes.string,
        jsonData: PropTypes.shape({
            sku_min_fin_amt: PropTypes.number,
            sku_max_fin_amt: PropTypes.number,
            sku_create_id: PropTypes.string,
            variant: PropTypes.string,
            model: PropTypes.string,
        })
    }).isRequired
};

export default Summary;
